import type { FormReadCorrection } from "./corrections";
import { useJudgeReading } from "./useFormReadReview";

export function JudgeReading({ row }: { row: FormReadCorrection }) {
  const { data: reading } = useJudgeReading(row);
  if (!reading?.handwriting) return null;

  return (
    <section aria-label="Judge's handwriting reading" className="space-y-1 border-t p-3">
      <h2 className="text-xs font-medium text-muted-foreground">Judge's handwriting reading</h2>
      <p className="whitespace-pre-wrap text-sm">{reading.handwriting}</p>
    </section>
  );
}
